import { motion } from "framer-motion";

// Общая оболочка модальных окон киоска: затемнение + белая карточка.
// Раньше каждая модалка рисовала свой тёмный блок #3A3A3A — после редизайна
// они должны выглядеть одинаково, поэтому оформление живёт здесь.
//
// tone: "accent" (по умолчанию, синий круг) | "warn" (песочный) | "danger" (красный)
const TONES = {
    accent: { bg: "#E3ECFB", stroke: "#246CE2" },
    warn: { bg: "#F7EEDC", stroke: "#B07B22" },
    danger: { bg: "#F7E1DC", stroke: "#C2543E" },
};

function KioskModal({
    icon,
    tone = "accent",
    title,
    description,
    children,
    footer,
    titleKey,
    descriptionKey,
    zClass = "z-50",
}) {
    const palette = TONES[tone] || TONES.accent;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className={`fixed inset-0 ${zClass} flex items-center justify-center bg-[rgba(18,22,31,0.45)]`}
            role="dialog"
            aria-modal="true"
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.94, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.94, y: 20 }}
                transition={{ duration: 0.28 }}
                className="w-[74vw] bg-white rounded-[4vh] shadow-[0_3vh_8vh_rgba(18,22,31,0.28)] px-[4vw] py-[3.4vh] flex flex-col items-center text-center"
            >
                {icon && (
                    <div
                        className="w-[11vh] h-[11vh] rounded-full flex items-center justify-center mb-[2.4vh]"
                        style={{ background: palette.bg, color: palette.stroke }}
                    >
                        {icon}
                    </div>
                )}

                {/* key на motion-элементе — чтобы смена языка проигрывалась плавно */}
                <motion.h2
                    key={`title-${titleKey ?? ""}`}
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-[3vh] font-extrabold tracking-tight"
                >
                    {title}
                </motion.h2>

                {description && (
                    <motion.p
                        key={`desc-${descriptionKey ?? ""}`}
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: 0.05 }}
                        className="text-[1.8vh] font-semibold text-[#7B8290] mt-[1.2vh] leading-snug max-w-[60vw]"
                    >
                        {description}
                    </motion.p>
                )}

                {children}

                {footer && <div className="w-full mt-[2.6vh]">{footer}</div>}
            </motion.div>
        </motion.div>
    );
}

export default KioskModal;
